export const TITLE_BAR_TEXT_HEIGHT = 20;
export const TITLE_BAR_TEXT_WIDTH = 140;

export const TOOLBAR_TILE_SIZE = 60;
export const TOOLBAR_TILE_COUNT = 3;

export const SECTION_HEADER_HEIGHT = 20;
export const SECTION_HEADER_WIDTH = '55%';

export const ROW_LABEL_HEIGHT = 12;

export const SWATCH_WIDTH = 48;
export const SWATCH_HEIGHT = 32;

export const SLIDER_HEIGHT = 32;

export const DROPDOWN_HEIGHT = 40;

/** Distinct widths so the label bricks do not all look uniform. */
export const ROW_LABEL_WIDTHS = [90, 60, 110, 70, 100, 80] as const;
